var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecived(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icofont/read") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Zeplin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Specs"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tokens-/-icons-/-message-/-sent",
    filter: ""
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.1660251,2.87596228 C11.4793402,3.08483896 11.5847906,3.48866411 11.4287487,3.81929865 L11.3740377,3.91602515 L5.37403772,12.9160251 C5.15038341,13.2515066 4.70731701,13.3453585 4.37046838,13.1470249 L4.28147871,13.0856516 L0.531478714,10.0856516 C0.208032263,9.82689445 0.155591232,9.35492517 0.414348393,9.03147871 C0.649582176,8.73743649 1.06102432,8.66736568 1.37689801,8.85146372 L1.46852129,8.91434839 L4.579,11.403 L10.1259623,3.08397485 C10.3557266,2.73932834 10.8213786,2.64619793 11.1660251,2.87596228 Z M15.6660251,2.87596228 C15.9793402,3.08483896 16.0847906,3.48866411 15.9287487,3.81929865 L15.8740377,3.91602515 L9.87403772,12.9160251 C9.65038341,13.2515066 9.20731701,13.3453585 8.87046838,13.1470249 L8.78147871,13.0856516 L7.62323978,12.1590605 C7.29979333,11.9003033 7.24735229,11.428334 7.50610946,11.1048876 C7.74134324,10.8108453 8.15278538,10.7407745 8.46865907,10.9248726 L8.56028235,10.9877572 L9.079,11.402 L14.6259623,3.08397485 C14.8557266,2.73932834 15.3213786,2.64619793 15.6660251,2.87596228 Z",
    id: "Combined-Shape",
    fill: "#87C71A",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecived);
export default __webpack_public_path__ + "static/media/recived.2b93c157.svg";
export { ForwardRef as ReactComponent };